/* tslint:disable */
import {
  Notification
} from '../index';

declare var Object: any;
export interface NotificationTypeInterface {
  "name"?: string;
  "displayName"?: string;
  "data"?: any;
  "options"?: any;
  "active"?: boolean;
  "createdAt"?: Date;
  "createdBy"?: number;
  "updatedAt"?: Date;
  "updatedBy"?: number;
  "id"?: number;
  notification?: Notification[];
}

export class NotificationType implements NotificationTypeInterface {
  "name": string;
  "displayName": string;
  "data": any;
  "options": any;
  "active": boolean;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  notification: Notification[];
  constructor(data?: NotificationTypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `NotificationType`.
   */
  public static getModelName() {
    return "NotificationType";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of NotificationType for dynamic purposes.
  **/
  public static factory(data: NotificationTypeInterface): NotificationType{
    return new NotificationType(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'NotificationType',
      plural: 'NotificationTypes',
      path: 'NotificationTypes',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string',
          default: 'false'
        },
        "displayName": {
          name: 'displayName',
          type: 'string',
          default: 'false'
        },
        "data": {
          name: 'data',
          type: 'any'
        },
        "options": {
          name: 'options',
          type: 'any'
        },
        "active": {
          name: 'active',
          type: 'boolean',
          default: true
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        notification: {
          name: 'notification',
          type: 'Notification[]',
          model: 'Notification',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'notificationTypeId'
        },
      }
    }
  }
}
